import { createWire } from '@forminator/react-wire'

/** @type StateWire<GEscrow[]> */
export const escrows = createWire([])
